import { render } from "./BrandHeader.vue?vue&type=template&id=3230c214"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__